// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"IsH63nwt","mobile":"mobile","scroller":"TvsvKW2c"};